module.exports = __webpack_public_path__ + "img/logobai.88718282.png";